import { useVenueContext } from '@/services/venue'
import { isBrowser } from '@/utils/env'
import { getVenueCurrency } from 'shared/venue'
import { formatPrice } from 'shared/utils/string'

export function usePrice(params?: { useGrouping?: boolean; currency?: string }) {
  const venueContext = useVenueContext()!
  const venue = venueContext.venue

  const language = (() => {
    const fallbackLang = 'ru'
    if (!isBrowser) {
      return fallbackLang
    }

    return venue.language ?? fallbackLang
  })()

  const currency = params?.currency ?? getVenueCurrency(venue)

  return {
    format(value: number) {
      return formatPrice(value, {
        language,
        currency,
        useGrouping: !!params?.useGrouping,
      })
    },
  }
}
